var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('PageHeader',{attrs:{"title":_vm.$t('Reports'),"description":_vm.$t('Sales returns by invoice')}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_c('i',{staticClass:"fal fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('Reports options'))+" ")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('Customer'),"plaseholder":_vm.$t('Choose customer'),"show":'name',"refrance":'id',"value":_vm.params.customer_id,"values":_vm.$database.customers},model:{value:(_vm.params.customer_id),callback:function ($$v) {_vm.$set(_vm.params, "customer_id", $$v)},expression:"params.customer_id"}}),_c('dateFilter',{staticClass:"col-md-3"}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('user'),"plaseholder":_vm.$t('Choose user'),"show":'name',"refrance":'id',"value":_vm.params.user_id,"values":_vm.$database.users},model:{value:(_vm.params.user_id),callback:function ($$v) {_vm.$set(_vm.params, "user_id", $$v)},expression:"params.user_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('project'),"plaseholder":_vm.$t('Choose project'),"show":'name',"refrance":'id',"value":_vm.params.project_id,"values":_vm.$database.projects},model:{value:(_vm.params.project_id),callback:function ($$v) {_vm.$set(_vm.params, "project_id", $$v)},expression:"params.project_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('Store'),"plaseholder":_vm.$t('Choose store'),"show":'name',"refrance":'id',"value":_vm.params.store_id,"values":_vm.$database.stores},model:{value:(_vm.params.store_id),callback:function ($$v) {_vm.$set(_vm.params, "store_id", $$v)},expression:"params.store_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('Point of sale'),"plaseholder":_vm.$t('Choose point of sale'),"show":'name',"refrance":'id',"value":_vm.params.point_of_sale_id,"values":_vm.$database.pointOfSales},model:{value:(_vm.params.point_of_sale_id),callback:function ($$v) {_vm.$set(_vm.params, "point_of_sale_id", $$v)},expression:"params.point_of_sale_id"}}),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('Session number')))]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.session_number),expression:"params.session_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('Enter session number')},domProps:{"value":(_vm.params.session_number)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.params, "session_number", $event.target.value)}}})])]),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('Order type')))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.table_number),expression:"params.table_number"}],staticClass:"form-control",attrs:{"type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "table_number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('Choose Order type')))]),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('Take away')))]),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('Indoor')))])])])]),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('Status type')))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",attrs:{"type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('Situation')))]),_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('all')))]),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('draft')))]),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('sent')))]),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('seen')))]),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('driven')))]),_c('option',{attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$t('canceled')))])])])]),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":_vm.$t('Shipping agent'),"plaseholder":_vm.$t('Choose shipping agent'),"show":'name',"refrance":'id',"value":_vm.params.delivery_id,"values":_vm.$database.deliveries},model:{value:(_vm.params.delivery_id),callback:function ($$v) {_vm.$set(_vm.params, "delivery_id", $$v)},expression:"params.delivery_id"}}),_c('actionButtons',{staticClass:"col-md-3"})],1)])]),_c('div',{attrs:{"id":"reportShow"}},[_c('reportHeader',{attrs:{"title":_vm.$t('Sales returns by invoice'),"details":[
            { title: _vm.$t('Customer name'), value: _vm.customerName },
            { title: _vm.$t('Username'), value: _vm.userName },
            { title: _vm.$t('Store'), value: _vm.storeName },
            { title: _vm.$t('Point of sale'), value: _vm.pointOfSaleName },
            { title: _vm.$t('Session number'), value: _vm.sessionNumber },
            { title: _vm.$t('Order type'), value: _vm.tableNumber },
            { title: _vm.$t('Shipping agent'), value: _vm.deliveryName },
            { title: _vm.$t('Marketer'), value: _vm.marketerName }
          ]}}),_c('reportTable',{attrs:{"emptyTableText":_vm.$t('there are no data at the moment'),"emptyTableSubText":_vm.$t('Try adding some items and try again'),"cloumns":[
            {
              column: 'code',
              link: '/saleReturns',
              title: _vm.$t('Code'),
              type: 'reportMainLink',
              sort: true
            },
            {
              column: 'date',
              title: _vm.$t('Date'),
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'client_type',
              title: _vm.$t('Customer name'),
              type: 'clintLink',
              sort: false
            },
            {
              column: 'user',
              title: _vm.$t('User'),
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'subtotal',
              title: _vm.$t('Total'),
              type: 'text',
              sort: true
            },
            {
              column: 'edit',
              title: _vm.$t('Edit'),
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'delivery',
              title: _vm.$t('Shipping fees'),
              type: 'text',
              sort: true
            },
            {
              column: 'tax',
              title: _vm.$t('Taxes'),
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'discount',
              title: _vm.$t('Discount'),
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'total',
              title: _vm.$t('Total'),
              type: 'text',
              sort: true
            },
            {
              column: 'earning',
              title: 'الخسارة',
              type: 'text',
              sort: true,
              disable: !(this.$user.admin || this.$user.role.reports_earning_show),
              supData: true
            }
          ],"footer":[
            { colspan: 1, value: _vm.$t('Total') },
            { colspan: 3, value: _vm.invoicesCount, supData: true },
            { colspan: 1, value: _vm.subtotal },
            {
              colspan: 1,
              value: _vm.edit,
              supData: true
            },
            { colspan: 1, value: _vm.delivery },
            {
              colspan: 1,
              value: _vm.tax,
              supData: true
            },
            {
              colspan: 1,
              value: _vm.discount,
              supData: true
            },
            { colspan: 1, value: _vm.total },
            {
              colspan: 1,
              value: _vm.earning,
              disable: !(this.$user.admin || this.$user.role.reports_earning_show),
              supData: true
            }
          ]}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }